module.exports = __webpack_public_path__ + "static/media/property-on.bef132ec.svg";